enum MonitoringFilterFieldNames {
  Entity = 'entity',
  FilterPresetConfig = 'filterPresetConfig',
  FilterPresetId = 'id',
  FormCategory = 'formCategory',
  FormTemplateName = 'formTemplateName',
  LastUpdate = 'lastUpdate',
  Legend = 'legend',
  Name = 'name',
  Period = 'period',
  Sectors = 'sectors',
  SectorToAdd = 'sectorsToAdd',
  Sites = 'sites',
  SiteToAdd = 'siteToAdd',
  Status = 'status',
}

export default MonitoringFilterFieldNames;
